// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","highlight_alt":"#7971EA","primary_font":"\"Montserrat\", sans-serif","secondary_font":"Futura, sans-serif","mobile":"only screen and (max-width: 767px)","footer":"footer__34BaK","copyright":"copyright__3XvKT"};


//////////////////
// WEBPACK FOOTER
// ./components/Footer/style.css
// module id = n4o+
// module chunks = 0